import script from "./TreeQueryWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeQueryWidget.vue?vue&type=script&setup=true&lang=js"

import "./TreeQueryWidget.vue?vue&type=style&index=0&id=7fdec9ea&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fdec9ea"]])

export default __exports__